export const questions = [
  {
    question: "Q1. What’s your first name?",
    fieldKey: "firstName",
    isRequired: true,
    isShowSkipButton: true,
    isShowNextButton: false,
    isShowSection: true,
    type: "text",
    value: "",
  },
  {
    question: "Q2. What’s your last name?",
    fieldKey: "lastName",
    isRequired: true,
    isShowSkipButton: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "text",
  },
    {
    question: "Q3. What’s your email ?",
    fieldKey: "email",
    isRequired: true,
    isShowSkipButton: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "email",
  },
  {
    question: "Q4. What’s your middle name?",
    fieldKey: "middleName",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "text",
  },
  // {
  //   question: "Q3. What’s your company name?",
  //   fieldKey: "company",
  //   isRequired: true,
  //   isShowSkipButton: false,
  //   isShowNextButton: false,
  //   isShowSection: false,
  //   value: "",
  //   type: "text",
  // },
  {
    question: "Q5. What’s your secondary email ?",
    fieldKey: "secondaryEmail",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "email",
  },
  {
    question: "Q6. What’s your primary phone number?",
    fieldKey: "primaryPhoneNumber",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "mobileNumber",
  },
  {
    question: "Q7. What’s your secondary phone number?",
    fieldKey: "secondaryPhoneNumber",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "mobileNumber",
  },
  {
    question: "Q8. What is the Lead Value?",
    fieldKey: "leadValue",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "number",
  },
  {
    question: "Q9. What’s your age (years)?",
    fieldKey: "age",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "age",
  },
  {
    question: "Q10. What’s your Fax Number?",
    fieldKey: "fax",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "number",
  },
  {
    question: "Q11. What’s your company’s website?",
    fieldKey: "website",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "website",
  },
  // {
  //   question: "Q10. How many Employees does the company have?",
  //   fieldKey: "numEmployees",
  //   isShowSkipButton: true,
  //   isRequired: false,
  //   isShowNextButton: false,
  //   isShowSection: false,
  //   value: "",
  //   type: "number",
  // },
  {
    question: "Q12. Which Industry does the company belong to?",
    fieldKey: "industry",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "textNumber",
  },
  {
    question: "Q13. What’s your designation?",
    fieldKey: "designation",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "textNumber",
  },

  // {
  //   question: "Q14. Which product are you interested in?",
  //   fieldKey: "interestedProduct",
  //   isShowSkipButton: true,
  //   isRequired: false,
  //   isShowNextButton: false,
  //   isShowSection: false,
  //   value: "",
  //   type: "interestedProductDropdown",
  // },
  {
    question: "Q14. What is your street line 1?",
    fieldKey: "streetLine1",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "textNumber",
  },
  {
    question: "Q15. What is your street line 2?",
    fieldKey: "streetLine2",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "textNumber",
  },
  {
    question: "Q16. Which city are you located in?",
    fieldKey: "city",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "text",
  },
  {
    question: "Q17. Which state are you located in?",
    fieldKey: "state",
    isShowSkipButton: true,
    isShowNextButton: false,
    isRequired: false,
    isShowSection: false,
    value: "",
    type: "text",
  },
  {
    question: "Q18. Which country are you located in?",
    fieldKey: "country",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "text",
  },
  {
    question: "Q19. What is your ZIP code?",
    fieldKey: "zipcode",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "number",
  },
  {
    question: "Q20. Do you have any additional details ?",
    fieldKey: "description",
    isShowSkipButton: true,
    isRequired: false,
    isShowNextButton: false,
    isShowSection: false,
    value: "",
    type: "text",
  },
  {
    question: "All Done !",
    fieldKey: "",
    isShowSkipButton: false,
    isShowNextButton: false,
    isShowSection: false,
    isVoice: false,
  },
];

export const initialValues = {
  title: "",
  company: "",
  firstName: "",
  lastName: "",
  email: "",
  secondaryEmail: "",
  fax: "",
  website: "",
  numEmployees: "",
  annualRevenue: "",
  interestedProduct: "",
  socialLeadId: "",
  streetLine1: "",
  streetLine2: "",
  description: "",
  city: "",
  state: "",
  country: "",
  zipcode: "",
  primaryPhoneNumber: "",
  secondaryPhoneNumber: "",
  imageUrl: null,
  industry: "",
  designation: "",
  middleName: "",
  age: "",
  leadValue: "",
};
